import React from "react";
import classNames from "classnames";

import { CloseIcon } from "@common/assets/closeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Modal({
  header,
  children,
  headerClassName,
  className,
  closeIconClassName,
  close,
}: Props) {
  return (
    <div
      className={classNames(styles.modal, {
        [`${className}`]: !!className,
      })}
    >
      <div
        className={classNames(styles.header, {
          [`${headerClassName}`]: !!headerClassName,
        })}
      >
        {typeof header === "string" ? (
          <h1 className={styles.title}>{header}</h1>
        ) : (
          header
        )}
        <div onClick={close} className={styles.iconBox}>
          <CloseIcon
            className={classNames(styles.icon, {
              [`${closeIconClassName}`]: !!closeIconClassName,
            })}
          />
        </div>
      </div>
      {children}
    </div>
  );
}

export { Modal };
